export var ITile;
(function (ITile) {
    let ISduiProductTile;
    (function (ISduiProductTile) {
        let ISduiProductTileBrandInfo;
        (function (ISduiProductTileBrandInfo) {
            /**
             * Return an instance of ISduiProductTileBrandInfo with the provided fields. Any field not
             * listed will be populated with an empty value (an empty array,
             * or undefined, whichever is valid for the type of the value.)
             */
            ISduiProductTileBrandInfo.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
        })(ISduiProductTileBrandInfo = ISduiProductTile.ISduiProductTileBrandInfo || (ISduiProductTile.ISduiProductTileBrandInfo = {}));
        /**
         * Return an instance of ISduiProductTile with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        ISduiProductTile.build = (partial) => (Object.assign({ badges: [] }, (partial !== null && partial !== void 0 ? partial : {})));
    })(ISduiProductTile = ITile.ISduiProductTile || (ITile.ISduiProductTile = {}));
    let ISduiBrandTile;
    (function (ISduiBrandTile) {
        /**
         * Return an instance of ISduiBrandTile with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        ISduiBrandTile.build = (partial) => (Object.assign({ badges: [] }, (partial !== null && partial !== void 0 ? partial : {})));
    })(ISduiBrandTile = ITile.ISduiBrandTile || (ITile.ISduiBrandTile = {}));
    let ProductTileVariant;
    (function (ProductTileVariant) {
        ProductTileVariant["PRODUCT_TILE_VARIANT_UNKNOWN"] = "PRODUCT_TILE_VARIANT_UNKNOWN";
        /**
         * Tile with square product image and product name, App only
         * @deprecated
         */
        ProductTileVariant["DEFAULT_PRODUCT_TILE"] = "DEFAULT_PRODUCT_TILE";
        /**
         * Web + App
         */
        ProductTileVariant["IMAGE_ONLY_TILE"] = "IMAGE_ONLY_TILE";
        /**
         * Web + App - image only tile with price in bottom left corner
         * @deprecated
         */
        ProductTileVariant["IMAGE_ONLY_TILE_WITH_PRICE"] = "IMAGE_ONLY_TILE_WITH_PRICE";
        /**
         * Web + App - all tiles are from the same brand
         */
        ProductTileVariant["EVALUATE_TILE"] = "EVALUATE_TILE";
        /**
         * Web + App - tiles are from many brands
         */
        ProductTileVariant["DISCOVERY_TILE"] = "DISCOVERY_TILE";
    })(ProductTileVariant = ITile.ProductTileVariant || (ITile.ProductTileVariant = {}));
    let ITileStyle;
    (function (ITileStyle) {
        /**
         * Return an instance of ITileStyle with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        ITileStyle.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
    })(ITileStyle = ITile.ITileStyle || (ITile.ITileStyle = {}));
    /**
     * Return an instance of ITile with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    ITile.build = (partial) => (Object.assign({ on_view: [], on_click: [] }, (partial !== null && partial !== void 0 ? partial : {})));
})(ITile || (ITile = {}));
